import { useContext } from 'react'
import { ThemeContext } from './contexts/theme'
import Header from './components/Header/Header'
import About from './components/About/About'
import Projects from './components/Projects/Projects'
import Experience from './components/Experience/Experience'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'
import './App.css'

const App = () => {
  const { themeName } = useContext(ThemeContext);

  return (
    <div className={`${themeName} app`}>
      <div className="content">
        <Header />
        <main>
          <About />
          <Projects />
          <Experience />
          <Contact />
        </main>
        <ScrollToTop />
        <Footer />
      </div>
    </div>

  )
}

export default App
